/**
 * AgentsHubPage — 2026-08-19.
 *
 * Wraps the existing AgentsPage (human agents — unmodified, ~1200 lines,
 * left completely untouched rather than surgically rewrapping its JSX)
 * and the new DigitalCompanionPage behind a "Human Agents" / "Digital
 * Companion" tab switcher, per direct request: Digital Companion should
 * live as a subtab of Agents, not its own top-level sidebar item.
 *
 * Deliberately composition over rewrite — both child pages keep managing
 * their own data fetching/state exactly as before; this component only
 * decides which one is visible.
 */
import React from 'react';
import { Users, Bot } from 'lucide-react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../components/ui/tabs';
import AgentsPage from './AgentsPage';
import DigitalCompanionPage from './DigitalCompanionPage';

const AgentsHubPage: React.FC = () => {
  return (
    <Tabs defaultValue="digital-companion" className="flex flex-1 flex-col min-h-0">
      <div className="border-b border-border px-4 pt-3 md:px-6">
        <TabsList>
          <TabsTrigger value="digital-companion" className="gap-1.5">
            <Bot className="h-3.5 w-3.5" />
            Digital Companion
          </TabsTrigger>
          <TabsTrigger value="human" className="gap-1.5">
            <Users className="h-3.5 w-3.5" />
            Human Agents
          </TabsTrigger>
        </TabsList>
      </div>

      <TabsContent value="digital-companion" className="mt-0 flex-1 min-h-0 overflow-y-auto">
        <DigitalCompanionPage />
      </TabsContent>
      <TabsContent value="human" className="mt-0 flex-1 min-h-0">
        <AgentsPage />
      </TabsContent>
    </Tabs>
  );
};

export default AgentsHubPage;
